import { MDBBadge, MDBBtn, MDBIcon, MDBTable } from "mdbreact";
import bridges from "../../../../services/fakeDb/bridges";

const downloadBridgeFile = (bridge = {}) => {
  if (bridge.downloadUrl) {
    const link = document.createElement("a");

    link.href = bridge.downloadUrl;
    link.download = bridge.fileName || "";
    document.body.appendChild(link);
    link.click();
    link.remove();
    return;
  }

  const lines = [
    `Bridge: ${bridge.name || ""}`,
    `Code: ${bridge.code || ""}`,
    `Protocol: ${bridge.protocol || ""}`,
    `Version: ${bridge.version || ""}`,
    `Release Date: ${bridge.releaseDate || ""}`,
    "",
    bridge.description || "",
    "",
    "Notes:",
    ...(bridge.notes || []).map((note) => `- ${note}`),
  ];

  const blob = new Blob([lines.join("\n")], {
    type: "text/plain;charset=utf-8",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = bridge.fileName || `${bridge.code || "bridge"}.txt`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const Body = () => {
  return (
    <MDBTable responsive hover bordered className="mb-0 bridge-download-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Analyzer Bridge</th>
          <th>Protocol</th>
          <th>Version</th>
          <th>File</th>
          <th>Release Date</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {bridges.map((bridge, index) => (
          <tr key={bridge._id || bridge.code || index}>
            <td>{index + 1}</td>
            <td>
              <div className="font-weight-bold">{bridge.name}</div>
              <small className="text-muted d-block">{bridge.description}</small>
            </td>
            <td>{bridge.protocol}</td>
            <td>{bridge.version}</td>
            <td className="text-uppercase">{bridge.fileType || "txt"}</td>
            <td>{bridge.releaseDate}</td>
            <td>
              <MDBBadge color="success">{bridge.status}</MDBBadge>
            </td>
            <td>
              <MDBBtn
                size="sm"
                color="primary"
                onClick={() => downloadBridgeFile(bridge)}
              >
                <MDBIcon icon="download" className="mr-2" />
                Download
              </MDBBtn>
            </td>
          </tr>
        ))}
      </tbody>
    </MDBTable>
  );
};

export default Body;
